import { render, staticRenderFns } from "./EventTypeContent.vue?vue&type=template&id=56a35a7a"
import script from "./EventTypeContent.vue?vue&type=script&lang=js"
export * from "./EventTypeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports